<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;
  grid-template-columns: auto auto; grid-column-gap: 0.5rem;grid-auto-flow: row dense;">
			<el-form-item v-for="(item,index) in dialog_span" :key="index" :label="item.name" :prop="item.model">
				<el-input :disabled="true" v-model="inputmodel[`${item.model}`]" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="房源编号" prop="room_num"><br>
				<el-select style="width: 100%;" v-model="inputmodel.room_num" placeholder="请选择房间"
					v-el-select-loadmore="loadmore" @change="changeselect">
					<el-option v-for=" item in options" :key="item.id" :label="item.flat+`—`+item.room_num"
						:value="item.room_num">
					</el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>
<script>
	import {
		house_list,
		bind_meters_room
	} from "@/api/api.js"
	import {
		BASEURL
	} from "@/Utils/request.js";

	export default {
		directives: {
			'el-select-loadmore': {
				bind(el, binding) {
					const SELECTWRAP_DOM = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
					SELECTWRAP_DOM.addEventListener('scroll', function() {
						const condition = this.scrollHeight - this.scrollTop <= this.clientHeight;
						if (condition) {
							binding.value();
						}
					});
				}
			}
		},
		props: [
			"item"
		],
		data() {
			return {
				name: '',
				dialog_span: [{
					name: '设备编号',
					model: 'device_no'
				}, {
					name: '设备名称',
					model: 'name'
				}],
				inputmodel: {
					device_no: '',
					rid: '',
					room_num: '',
				},
				rules: {},
				options: [],
				formData: {
					page: 1,
					limit: 10,
					rent_status: 0
				},
			}
		},
		methods: {
			qx(i) {
				console.log(this.inputmodel);
				if (i != 1) {
					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {
							bind_meters_room({
								device_no: this.inputmodel.device_no,
								rid: this.inputmodel.rid,
								room_num: this.inputmodel.room_num
							}).then(res => {
								this.Messages(res)
								if (res.status == 200) {
									this.inputmodel = {}
									this.$emit('changedia', false)
									this.$parent.$parent.$parent.contractlistcontractlist();
								}
							})
						}
					})
				} else {
					// this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			loadmore() {
				console.log(this.formData.limit);
				this.formData.page++;
				let sum = this.formData.limit
				// this.formData.limit = sum - (10 * (this.formData.page - 1))
				// if (this.formData.limit >= 0) {
				// this.getList(this.formData);
				// }
				// console.log(this.formData);
			},
			getList(formData) {
				house_list(formData).then(res => {
					const _res = res.data
					this.options = [...this.options, ..._res];
				})

			},
			changeselect(value) {
				// value 是被选中的房间号
				console.log('Selected room number:', value);
				// 根据 value 查找对应的 item
				const selectedItem = this.options.find(item => item.room_num === value);
				if (selectedItem) {
					console.log('Selected item:', selectedItem);
					this.inputmodel.rid = selectedItem.id
				}
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			}
		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}]
			};
			house_list({
				limit: 999999999,
				page: 1
			}).then(res => {
				const _res = res.data.list
				this.options = _res;
			})
			this.inputmodel = JSON.parse(JSON.stringify(this.item));
		},
		watch: {
			item: function(newVal, oldVal) {
				console.log('newVal', newVal);

				this.inputmodel = JSON.parse(JSON.stringify(this.item));


			}
		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>